import { ALL_GAMES, type GameName } from "../types.ts";

/**
 * Read each game's localStorage stats to find which games
 * have been completed today. Works for anonymous users.
 */
export function getLocalCompletedGames(): Set<GameName> {
  const now = new Date();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  const completed = new Set<GameName>();

  for (const game of ALL_GAMES) {
    try {
      const raw = localStorage.getItem(`${game}-stats`);
      if (!raw) continue;
      const stats = JSON.parse(raw);
      if (stats?.history?.[today]?.completed) {
        completed.add(game);
      }
    } catch {}
  }

  return completed;
}
